import { useEffect } from "react"

/**
 * Глобальный счётчик открытых оверлеев: несколько модалок подряд не снимут блокировку раньше времени.
 * Блокируем и `document.documentElement`, и `body` — так надёжнее на iOS/Safari, чем только `body`.
 */
let scrollLockDepth = 0
let storedHtmlOverflow = ""
let storedBodyOverflow = ""

const applyDocumentScrollLock = () => {
  const html = document.documentElement
  const body = document.body
  storedHtmlOverflow = html.style.overflow
  storedBodyOverflow = body.style.overflow
  html.style.overflow = "hidden"
  body.style.overflow = "hidden"
}

const restoreDocumentScrollLock = () => {
  document.documentElement.style.overflow = storedHtmlOverflow
  document.body.style.overflow = storedBodyOverflow
}

const incrementScrollLock = () => {
  if (scrollLockDepth === 0) {
    applyDocumentScrollLock()
  }
  scrollLockDepth += 1
}

const decrementScrollLock = () => {
  scrollLockDepth = Math.max(0, scrollLockDepth - 1)
  if (scrollLockDepth === 0) {
    restoreDocumentScrollLock()
  }
}

/** Блокирует скролл страницы под модалками, пока `active === true`. */
export const useBodyScrollLock = (active: boolean) => {
  useEffect(() => {
    if (!active) return
    incrementScrollLock()
    return () => {
      decrementScrollLock()
    }
  }, [active])
}
